module.exports = __webpack_public_path__ + "img/Withdraw-gold.3b68c9be.svg";